<template>
  <div class="sr-upload" :class="{ 'sr-upload--no-pointer': CLASS.NO_POINTER }" @mouseover="handleHover"
    @mouseout="handleOut" v-loading="cfg.loading">
    <div v-if="VISIBLE.ADD && VISIBLE.SHOW_EXAMPLE"
      :class="['view-dialog-wrap', exampleVisible ? 'view-dialog-wrap-active' : '']">
      <img :src="VISIBLE.SHOW_EXAMPLE" alt="">
    </div>
    <el-upload :class="{ 'sr-upload-content--long': longSize }" action="#" ref="uploadRef" :disabled="DISABLED.UPLOAD"
      :show-file-list="false" :auto-upload="true" :accept="fileType" :before-upload="beforeUpload"
      :http-request="uploadFile">
      <div class="slot-wrap" v-if="VISIBLE.SLOT_FLAG">
        <slot />
      </div>
      <div class="sr-upload-content" v-else>
        <div v-if="VISIBLE.ADD">
          <div class="sr-upload-content__example" @click="e => e.stopPropagation()">
            <img :src="uploadBgEnum[fileBG] || uploadBgEnum['otherMaterial']" alt="">
          </div>
          <div class="biz-upload" v-if="VISIBLE.BTN_DELETE">{{ desc }}</div>
        </div>
        <div v-else>
          <div>
            <div class="sr-upload-content__preview">
              <div v-if="VISIBLE.IMG" class="sr-upload-content__preview--img">
                <img :src="fileUrl || file.fileBase64 || remoteFile.fileUrl" alt="" />
              </div>
              <div v-if="VISIBLE.PDF" class="sr-upload-content__preview--other">
                <img :src="cfg.pdfUrl" alt="" />
              </div>
              <div v-if="VISIBLE.EXCEL" class="sr-upload-content__preview--other">
                <img :src="cfg.excelUrl" alt="" />
              </div>
              <div v-if="VISIBLE.COMPRESS" class="sr-upload-content__preview--other">
                <img :src="cfg.compressUrl" alt="" />
              </div>
            </div>
            <div class="sr-upload-content__actions" v-if="VISIBLE.OPERATE" @click="handlePrevent">
              <div class="sr-upload-content__actions--preview" @click="handlePreview">
                <a class="biz-view" :href="fileUrl || remoteFile.fileUrl"
                  target="_blank">{{ t('global.content.text_9') }}</a>
              </div>
              <div class="sr-upload-content__actions--delete" v-if="VISIBLE.BTN_DELETE">
                <span class="biz-delete">{{ t('global.content.text_10') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-upload>
    <div class="sr-upload-error sr-color-danger" v-if="VISIBLE.ERROR_STACK">
      {{ cfg.error.text }}
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, onMounted, watch, watchEffect, useSlots } from 'vue'

import { types } from '@/config'
import { uploadFile } from '@/api/modules/common'
import fileComp from '@/compositions/modules/file'
import commonComp from '@/compositions/modules/common'
import { useI18n } from '@/plugins/i18n'
import { commonUtils, vab } from '@libs/utils'

const { constant: { FILE } } = commonComp()

const PARAMS = {
  FILE_SIZE: {
    PAYLOAD: 1024 * 1024,
    INDEX: '20',
    ZERO: 0
  },
  FILE_TYPE: '.jpg,.jpeg,.png,.bmp,.pdf'
}

export default {
  name: 'sr-upload',
  props: {
    fileId: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    fileType: {
      type: String,
      default: PARAMS.FILE_TYPE
    },
    fileSize: {
      type: String,
      default: PARAMS.FILE_SIZE.INDEX
    },
    fileUrl: {
      type: String,
      default: ''
    },
    fileBizType: {
      type: String,
      default: FILE.BIZ_TYPE.KY
    },
    filePrefix: {
      type: String,
      required: true
    },
    fileExample: {
      type: String,
    },
    mode: {
      type: String,
      default: FILE.UPLOAD_MODE.EDITABLE
    },
    fileUploadStatus: {
      type: String,
      default: FILE.UPLOAD_STATUS.INIT
    },
    failReset: {
      type: Boolean,
      default: true
    },
    uploadDesc: {
      type: String
    },
    longSize: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const { getFileType, fileToBase64, getFileRemoteInfo } = fileComp()
    const { t } = useI18n()
    const uploadBgEnum = {
      frontFile: require('@/assets/img/components/sr-upload/font.png'),
      backFile: require('@/assets/img/components/sr-upload/back.png'),
      holdPhoto: require('@/assets/img/components/sr-upload/hold.png'),
      otherMaterial: require('@/assets/img/components/sr-upload/other.png'),
    }

    const scopedComp = { t }

    const state = reactive({
      file: {
        fileCopy: '',
        fileBase64: '',
        fileName: ''
      },
      uploadBgEnum,
      fileBG: props.filePrefix,
      desc: props.uploadDesc,
      remoteFile: {
        fileUrl: ''
      },
      cfg: {
        loading: false,
        pdfUrl: require('@/assets/img/components/sr-upload/pdf.png'),
        excelUrl: require('@/assets/img/components/sr-upload/excel.png'),
        compressUrl: require('@/assets/img/components/sr-upload/compress.png'),
        error: {
          text: '文件上传失败'
        }
      },
      exampleVisible: false,
    })

    const scopedComputed = {
      VISIBLE: computed(() => {
        return {
          ADD: (function () {
            return !props.fileUrl && !state.file.fileBase64 && !state.remoteFile.fileUrl
          })(),
          IMG: (function () {
            return types.image.includes(state.file.fileType)
          })(),
          PDF: (function () {
            return types.pdf.includes(state.file.fileType)
          })(),
          EXCEL: (function () {
            return types.excel.includes(state.file.fileType)
          })(),
          COMPRESS: (function () {
            return types.compress.includes(state.file.fileType)
          })(),
          BTN_DELETE: (function () {
            return props.mode === FILE.UPLOAD_MODE.EDITABLE
          })(),
          OPERATE: (function () {
            return props.mode !== FILE.UPLOAD_MODE.READONLY
          })(),
          ERROR_STACK: (function () {
            return props.fileUploadStatus === FILE.UPLOAD_STATUS.FAILED
          })(),
          SHOW_EXAMPLE: (function () {
            return props.fileExample ? props.fileExample : false
          })(),
          SLOT_FLAG: (function () {
            return !!useSlots().default
          })()
        }
      }),
      DISABLED: computed(() => {
        return {
          UPLOAD: (function () {
            return props.mode === FILE.UPLOAD_MODE.READONLY || false
          })()
        }
      }),
      CLASS: computed(() => {
        return {
          NO_POINTER: (function () {
            return props.mode === FILE.UPLOAD_MODE.READONLY || state.cfg.loading === false
          })()
        }
      })
    }

    const scopedMethods = {
      reset: () => {
        state.file = {
          fileCopy: '',
          fileBase64: '',
          fileName: props.fileName,
          fileType: props.fileType
        }

        state.remoteFile = {
          fileUrl: ''
        }
      },
      handleHover: () => {
        state.exampleVisible = true
      },
      handleOut: () => {
        state.exampleVisible = false
      },
      handlePrevent: (e) => {
        !scopedComputed.VISIBLE.value.BTN_DELETE && e.stopPropagation()
      },
      handlePreview: (e) => {
        e.stopPropagation()
      },
      handleRemove: (e) => {
        // e.stopPropagation()
        // reset - file
        scopedMethods.reset()
        // reset - fileId
        ctx.emit('update:fileId', '')
        // reset - fileUploadStatus
        ctx.emit('update:fileUploadStatus', FILE.UPLOAD_STATUS.INIT)
      },
      beforeUpload: (file) => {
        const fileType = getFileType(file)

        // set fileType
        state.file.fileType = fileType

        // validate - file type
        if (!props.fileType.includes('.' + fileType)) {
          vab.baseMessage(`上传文件类型只能是${props.fileType}`, 'error')

          return false
        }

        // validate - file size more than
        if (props.fileSize * PARAMS.FILE_SIZE.PAYLOAD < file.size) {
          vab.baseMessage(`上传文件大小不能超过 ${props.fileSize}MB!`, 'error')

          return false
        }

        // validate - file size less than
        if (PARAMS.FILE_SIZE.ZERO === file.size) {
          vab.baseMessage('上传文件不能为空！', 'error')

          return false
        }

        // set - file fileCopy
        state.file.fileCopy = file
        // set - file name
        state.file.fileName = file.name
      },
      uploadFile: async () => {
        try {
          state.cfg.loading = true
          // file - 文件上传中
          ctx.emit('update:fileUploadStatus', FILE.UPLOAD_STATUS.PROCESSING)

          state.file.fileBase64 = await fileToBase64(state.file.fileCopy)

          const param = {
            // 去除base64前缀
            fileBase64: state.file.fileBase64.replace(/^data:(.*?);base64,/, ''),
            fileType: props.fileBizType,
            filePrefix: props.filePrefix,
            srcFileName: state.file.fileName
          }

          const result = await uploadFile(param)
          const { fileId, fileName } = result

          ctx.emit('update:fileId', fileId)
          ctx.emit('update:fileName', fileName)
          // file - 文件上传成功
          ctx.emit('update:fileUploadStatus', FILE.UPLOAD_STATUS.SUCCESS)
          // validate - 文件上传成功，清空父组件校验信息
          ctx.emit('upload-success')
        } catch (e) {
          // file - 文件上传失败
          ctx.emit('update:fileUploadStatus', FILE.UPLOAD_STATUS.FAILED)
          props.failReset && scopedMethods.reset()
          // vab.baseMessage(`${state.cfg.error.text}: ${e.message}`, 'error')
        } finally {
          state.cfg.loading = false
        }
      },
      initRemoteFileUrl: async () => {
        if (props.fileId) {
          const { fileName, url } = await getFileRemoteInfo(props.fileId)

          state.remoteFile.fileUrl = url

          if (fileName) {
            state.file.fileType = getFileType({
              name: fileName
            })
          }
        }
      }
    }

    onMounted(() => {
      scopedMethods.reset()
      scopedMethods.initRemoteFileUrl()
    })

    // todo - watch
    watch(() => props.fileId, value => {
      if (value) {
        // assemble
        scopedMethods.initRemoteFileUrl()
      } else {
        // reset
        scopedMethods.reset()
      }
    })

    watchEffect(() => {
      state.desc = props.uploadDesc
    })

    return {
      ...scopedComp,
      ...toRefs(state),
      ...scopedComputed,
      ...scopedMethods
    }
  }
}
</script>

<!--suppress CssInvalidPseudoSelector -->
<style scoped lang="scss" rel="stylesheet/scss">
$--content-width: 220px;
$--content-height: 148px;

.sr-upload {
  display: inline-block;
  padding-right: $--padding-small;
  position: relative;
  line-height: normal;

  .view-dialog-wrap {
    position: absolute;
    width: 300px;
    top: -5000px;
    left: 50%;
    transform: translate(-50%, -103%);
    background-color: #fff;
    z-index: 1000;
    opacity: 0;
    padding: 8px 6px;
    box-shadow: #ddd 0 0 13px 1px;
    box-sizing: border-box;

    &>img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .view-dialog-wrap:before {
    display: block;
    content: '';
    background-color: #fff;
    width: 10px;
    height: 10px;
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%) rotate(-45deg);
  }

  .view-dialog-wrap-active {
    opacity: 1;
    top: 0;
  }

  .sr-upload-content {
    position: relative;
    background-color: $--bg-color-base;
    border: 1px dashed #c0ccda;
    border-radius: $--border-radius-base;
    box-sizing: border-box;
    width: $--content-width;
    height: $--content-height;
    cursor: pointer;
    line-height: 148px;
    vertical-align: top;
    overflow: hidden;

    .biz-upload {
      background: #EDF9FF;
      border: 1px solid #D8EBFF;
      border-radius: 23px;
      width: fit-content;
      height: 32px;
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      line-height: 32px;
      font-size: 14px;
      color: #409EFF;
      letter-spacing: 0;
      white-space: nowrap;
      padding: 0 8px;
    }

    .biz-view {
      background: #EDF9FF;
      border: 1px solid #D8EBFF;
      border-radius: 23px;
      width: 80px;
      height: 32px;
      font-size: 14px;
      color: #409EFF;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: 0;
    }

    .biz-delete {
      background: #FFF4F2;
      border: 1px solid #DB9696;
      border-radius: 23px;
      width: 80px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #DB9696;
      letter-spacing: 0;
    }

    &:deep(.el-upload) {
      width: 100%;
      height: 100%;
    }

    .sr-upload-content__preview {
      width: $--content-width;
      height: $--content-height;

      .sr-upload-content__preview--img {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          border-radius: $--border-radius-base;
        }
      }

      .sr-upload-content__preview--other {
        display: flex;
        justify-content: center;
        align-items: center;
        width: inherit;
        height: inherit;
      }
    }

    .sr-upload-content__example {
      position: absolute;
      width: $--content-width;
      height: $--content-height;
      left: 0;
      top: 0;
      border-radius: $--border-radius-base;
      cursor: default;
      opacity: 1;
      transition: opacity .3s;
      background-size: cover;

      &>img {
        width: 100%;
        display: block;
        height: auto;
        border-radius: $--border-radius-base;
      }
    }

    .sr-upload-content__actions {
      position: absolute;
      width: $--content-width;
      height: $--content-height;
      left: 0;
      top: 0;
      border-radius: $--border-radius-base;
      cursor: default;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: $--font-size-large;
      background-color: rgba(0, 0, 0, .5);
      transition: opacity .3s;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        padding: $--padding-small;
      }

      .sr-upload-content__actions--preview {
        cursor: pointer;
        flex: 1;
        height: 32px;
        display: flex;
        line-height: 32px;
        justify-content: center;
      }

      .sr-upload-content__actions--delete {
        cursor: pointer;
        flex: 1;
        height: 32px;
        display: flex;
        line-height: 32px;
        justify-content: center;
      }

    }

    .sr-upload-content__actions:hover {
      opacity: 1;
    }
  }

  .sr-upload-content:hover,
  .sr-upload-content:focus {
    border-color: $--color-primary;
    color: $--color-primary;
  }

  .sr-upload-error {
    font-size: $--font-size-small;
  }
}

.sr-upload--no-pointer {

  &:deep(.el-upload) {
    cursor: default;
  }
}
.sr-upload-content--long{
  width: 280px;
  :deep(.el-upload) {
    width: 100%;
    .sr-upload-content{
      width: 100%;
      .sr-upload-content__preview,.sr-upload-content__actions{
        width: 100%;
      }
      .sr-upload-content__example{
        width: 100%;
        img{
          width: 100%;
        }
      }
    }
  }

}
</style>
